import axios from "../../api/axios";
import useAuth from "./useAuth";

const useLogout = () => {
  const { setAuth, setIsAuthenticated } = useAuth();

  const logout = async () => {
    setAuth({});
    setIsAuthenticated(false);

    try {
      const response = await axios("/auth/logout");

      // Check if refreshToken in db?
      // Delete refreshToken in db
    } catch (err) {
      console.error(err);
    }
  };

  return logout;
};

export default useLogout;
